/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms, TableView } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { OmcPageComponent } from "@src/app/modules/agent/omc-page/omc-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const OmcPageNavRoute = new NavRoute('agent/omcs', ()=>OmcPageComponent, 'apartment').setCharts([
    { type: 'pie', picklist: 'managerId' } as ChartParms,
    { type: 'bar', picklist: 'managerId', number: 'expectedUnits' } as ChartParms,
    { type: 'pie', picklist: 'typeId' } as ChartParms,
]).setViews((u: User) => {
    return [
        {
            id: 'allmyomcs',
            name: 'My OMCs',
            helpText: 'All OMCs you are assigned to in any role; change the filter to view another team member\'s OMCs',
            filterFields: {
                mineOnlyUserId: u.id,
                name: null
            },
        },
        {
            id: 'myoomcs',
            name: 'My Managed OMCs',
            helpText: 'OMCs where you are the primary manager; change the filter to view another manager\'s OMCs',
            filterFields: {
                managerId: u.id,
                name: null
            },
        },
        {
            id: 'myadminoomcs',
            name: 'My Administered OMCs',
            helpText: 'OMCs where you are the administrator; change the filter to view another administrator\'s OMCs',
            filterFields: {
                adminId: u.id,
                name: null
            },
        },
        { id: 'allomcs', name: 'All Active OMCs',
            helpText: 'All active OMCs in the agency',
            filterFields: {
                name: null
            }
        },
        { id: 'archived', name: 'Archived OMCs',
            helpText: 'OMCs that have been archived',
            filterFields: {
                name: null,
                isCurrent: false,
            }
        }
    ] as TableView[]
});
